export default "__VITE_ASSET__D50WY4qd__"